import styled from "styled-components";

export const DayTitleH1 = styled.h1`
  font-size: 1rem;
  margin: 5px 0 0px 10px;
`;
